import { render, staticRenderFns } from "./ExpenseEligibilitySelector.vue?vue&type=template&id=b65e6e5e&scoped=true"
import script from "./ExpenseEligibilitySelector.vue?vue&type=script&lang=ts"
export * from "./ExpenseEligibilitySelector.vue?vue&type=script&lang=ts"
import style0 from "./ExpenseEligibilitySelector.vue?vue&type=style&index=0&id=b65e6e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65e6e5e",
  null
  
)

export default component.exports